export default import.meta.ROLLUP_FILE_URL_HFq3zVp2on$Zb0VkoI5inw